import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"




export default /*@__PURE__*/_defineComponent({
  ...{ name: 'Tooltip' },
  __name: 'Tooltip',
  props: {
    text: {},
    icon: { default: 'app:info' }
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createBlock(_component_q_icon, {
    class: "opacity-75",
    color: "brand-secondary",
    name: _ctx.icon
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_tooltip, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.text), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["name"]))
}
}

})